import type { LocalePack } from "./types";

const perks = [
  { title: "Keine Kaution", text: "Keine Kreditkarte und keine Kaution nötig – Zahlung per Debitkarte, Bar (EUR/RON) oder Überweisung." },
  { title: "Vollkasko inklusive", text: "RCA- und CASCO-Versicherung, Rovinieta und unbegrenzte Kilometer sind bei jeder Buchung enthalten." },
  { title: "Kostenlose Abholung", text: "Kostenlose Übergabe in unserem Büro in der Bulevardul Regina Elisabeta 33 oder direkt am Flughafen Henri Coandă (Otopeni)." },
  { title: "24/7 Übergabe & WhatsApp", text: "Rund um die Uhr erreichbar, Antwort in Minuten über WhatsApp +40738792499." },
];

export const de: LocalePack = {
  code: "de",
  htmlLang: "de",
  dir: "ltr",
  ui: {
    label: "Deutsch",
    nav: { country: "Rumänien", airports: "Flughäfen", cities: "Städte", guides: "Reiseführer" },
    bookCta: "Jetzt buchen",
    fleetCta: "Fahrzeuge ansehen",
    whatsappCta: "WhatsApp schreiben",
    fleetTitle: "Unsere Flotte",
    fleetSubtitle: "28 gepflegte Fahrzeuge für jeden Bedarf, ab 35 €/Tag",
    faqTitle: "Häufig gestellte Fragen",
    mapTitle: "So finden Sie uns",
    relatedTitle: "Das könnte Sie auch interessieren",
    priceNote: "Preise inkl. Vollkasko, Rovinieta und unbegrenzten Kilometern, ohne Kaution.",
    breadcrumbHome: "Startseite",
  },
  pages: {
    country: {
      slug: "",
      title: "Mietwagen Rumänien ab 35 €/Tag | carentals.ro",
      description: "Mietwagen Rumänien ohne Kaution, mit Vollkasko und unbegrenzten Kilometern. Kostenlose Abholung in Bukarest und am Flughafen Otopeni.",
      eyebrow: "Autovermietung in ganz Rumänien",
      h1: "Mietwagen Rumänien – unkompliziert, ohne Kaution",
      intro: "carentals.ro ist eine Bukarester Autovermietung mit 28 Fahrzeugen in der Flotte, die Reisende in ganz Rumänien mit fairen Preisen und transparenten Bedingungen bedient. Ob Geschäftsreise, Städtetrip oder Rundreise durch Siebenbürgen – wir stellen den passenden Wagen ab 35 €/Tag bereit, ganz ohne Kreditkarte oder Kaution.",
      perks,
      sections: [
        {
          h2: "Warum einen Mietwagen in Rumänien buchen?",
          body: [
            "Rumänien lässt sich mit dem eigenen Fahrplan am besten erkunden: von den Karpaten über das Donaudelta bis zur Schwarzmeerküste. Öffentliche Verkehrsmittel decken viele der schönsten Orte nur unzureichend ab, ein Mietwagen gibt Ihnen volle Flexibilität.",
            "Bei carentals.ro erhalten Sie moderne Fahrzeuge mit RCA- und CASCO-Versicherung, Rovinieta und unbegrenzten Kilometern inklusive – ohne versteckte Kosten und ohne Kaution, die auf Ihrer Karte blockiert wird.",
          ],
        },
        {
          h2: "Abholung und Übergabe",
          body: [
            "Die Fahrzeugübergabe erfolgt kostenlos in unserem Büro in der Bulevardul Regina Elisabeta 33 in Bukarest oder direkt am Flughafen Henri Coandă (Otopeni). Eine Lieferung an eine andere Adresse in Bukarest ist gegen eine Gebühr von 20 € möglich.",
            "Für Abholungen in anderen Städten wie Cluj, Iași, Timișoara oder Sibiu organisieren wir auf Anfrage per WhatsApp eine Überstellung mit individuellem Angebot. Die Übergabe ist rund um die Uhr möglich, auch bei späten Flugankünften.",
          ],
        },
        {
          h2: "Bezahlung ohne Kreditkarte und Kaution",
          body: [
            "Viele internationale Anbieter verlangen eine hohe Kaution auf der Kreditkarte. Bei carentals.ro entfällt das: Sie zahlen bequem mit Debitkarte, in bar (EUR oder RON) oder per Überweisung.",
            "So bleibt Ihr Reisebudget planbar, und Sie müssen sich keine Sorgen um blockierte Beträge machen. Die Preise starten bei 35 €/Tag inklusive aller wichtigen Leistungen.",
          ],
        },
      ],
      faqs: [
        { q: "Brauche ich eine Kreditkarte, um in Rumänien einen Mietwagen zu buchen?", a: "Nein. Bei carentals.ro zahlen Sie mit Debitkarte, bar in EUR oder RON, oder per Überweisung – eine Kreditkarte ist nicht erforderlich." },
        { q: "Ist eine Kaution nötig?", a: "Nein, wir verlangen keine Sicherheitsleistung oder Kaution, was die Buchung deutlich unkomplizierter macht." },
        { q: "Sind Versicherung und Vignette im Preis enthalten?", a: "Ja, RCA- und CASCO-Versicherung sowie die Rovinieta (Straßenvignette) und unbegrenzte Kilometer sind immer inklusive." },
        { q: "Wie kann ich buchen oder Fragen stellen?", a: "Am schnellsten über WhatsApp unter +40738792499, wir sind 24/7 erreichbar und antworten meist innerhalb weniger Minuten." },
      ],
      keywords: "Mietwagen Rumänien, Autovermietung Rumänien, Auto mieten Rumänien",
    },
    "airport-otopeni": {
      slug: "mietwagen-otopeni-flughafen",
      title: "Mietwagen Otopeni – Auto mieten Bukarest Flughafen",
      description: "Mietwagen Otopeni ohne Kaution: kostenlose Abholung am Flughafen Henri Coandă, Vollkasko und unbegrenzte Kilometer inklusive, ab 35 €/Tag.",
      eyebrow: "Flughafen Henri Coandă (OTP)",
      h1: "Mietwagen Otopeni – Auto mieten am Bukarest Flughafen",
      intro: "Direkt nach der Landung am Flughafen Otopeni steht Ihr Mietwagen bereit – ohne Wartezeit, ohne Kaution. carentals.ro übergibt Fahrzeuge kostenlos am Terminal, rund um die Uhr, auch bei verspäteten Flügen.",
      perks: [
        { title: "Kostenlose Abholung am Terminal", text: "Direkt am Flughafen Henri Coandă, ohne Zusatzkosten für die Übergabe." },
        { title: "Keine Kaution", text: "Keine Kreditkarte nötig, Zahlung per Debitkarte, bar oder Überweisung." },
        { title: "Vollkasko & Rovinieta inklusive", text: "RCA, CASCO und die Straßenvignette sind bereits im Preis enthalten." },
        { title: "24/7 auch bei Verspätung", text: "Unser Team wartet auf Sie, unabhängig von der Ankunftszeit Ihres Fluges." },
      ],
      sections: [
        {
          h2: "So funktioniert die Abholung am Flughafen Otopeni",
          body: [
            "Nach der Landung schreiben Sie uns kurz über WhatsApp, und ein Mitarbeiter bringt das Fahrzeug direkt zum Terminalbereich von Henri Coandă. Der gesamte Vorgang dauert meist nur wenige Minuten.",
            "Sie prüfen das Auto gemeinsam mit uns, unterschreiben den Vertrag und fahren los – ganz ohne Warteschlangen an einem Schalter im Terminal.",
          ],
        },
        {
          h2: "Mietwagen Otopeni ohne Kaution",
          body: [
            "Viele Reisende schätzen, dass am Flughafen Otopeni keine Kreditkarte für eine Kaution blockiert wird. Bei carentals.ro zahlen Sie einfach mit Debitkarte, bar in EUR oder RON, oder per Überweisung.",
            "So starten Sie Ihre Reise entspannt, ohne finanzielle Überraschungen und mit klar kalkulierbaren Kosten ab 35 €/Tag.",
          ],
        },
        {
          h2: "Rückgabe und Rückflug",
          body: [
            "Auch die Rückgabe erfolgt bequem am Flughafen, sodass Sie rechtzeitig zum Check-in gehen können. Planen Sie etwas Puffer ein, insbesondere bei Rückflügen am frühen Morgen.",
            "Bei Bedarf koordinieren wir die Übergabezeit flexibel per WhatsApp, damit alles reibungslos zu Ihrem Flugplan passt.",
          ],
        },
      ],
      faqs: [
        { q: "Wo genau erfolgt die Übergabe am Flughafen Otopeni?", a: "Direkt im Ankunftsbereich von Henri Coandă. Nach der Landung kontaktieren Sie uns per WhatsApp, und wir bringen das Fahrzeug zu Ihnen." },
        { q: "Kostet die Abholung am Flughafen extra?", a: "Nein, die Übergabe am Flughafen Otopeni ist bei carentals.ro kostenlos." },
        { q: "Was passiert bei Flugverspätung?", a: "Kein Problem, wir sind 24/7 erreichbar und passen die Übergabezeit an Ihre tatsächliche Ankunft an." },
        { q: "Kann ich das Auto auch woanders zurückgeben?", a: "Eine Lieferung nach Bukarest kostet 20 €, für andere Städte erstellen wir auf Anfrage per WhatsApp ein individuelles Angebot." },
      ],
      keywords: "Mietwagen Otopeni, Auto mieten Bukarest Flughafen, Mietwagen Flughafen Bukarest",
    },
    "airport-cluj": {
      slug: "mietwagen-cluj-flughafen",
      title: "Mietwagen Cluj Flughafen | carentals.ro",
      description: "Auto mieten am Flughafen Cluj (CLJ): Überstellung ab Bukarest auf Anfrage, Vollkasko und unbegrenzte Kilometer inklusive, ohne Kaution.",
      eyebrow: "Flughafen Cluj-Napoca (CLJ)",
      h1: "Mietwagen am Flughafen Cluj",
      intro: "Sie landen in Cluj-Napoca und möchten Siebenbürgen flexibel erkunden? carentals.ro liefert Fahrzeuge aus unserer Bukarester Flotte auf Anfrage bis zum Flughafen Cluj – transparent, ohne Kaution und mit Vollausstattung.",
      perks,
      sections: [
        {
          h2: "Mietwagen bis nach Cluj liefern lassen",
          body: [
            "Unsere Flotte mit 28 Fahrzeugen ist in Bukarest stationiert. Für den Flughafen Cluj organisieren wir auf Anfrage per WhatsApp eine Überstellung mit individuellem Angebot, das Entfernung und Termin berücksichtigt.",
            "So profitieren Sie auch in Siebenbürgen von unseren fairen Konditionen: keine Kaution, keine Kreditkarte nötig, dafür Vollkasko und Rovinieta inklusive.",
          ],
        },
        {
          h2: "Ideal für Reisen durch Siebenbürgen",
          body: [
            "Ab Cluj erreichen Sie schnell Städte wie Sibiu, Brașov oder Alba Iulia. Ein Mietwagen ist hier die bequemste Art, die Region mit ihren Burgen und Bergstraßen zu erkunden.",
            "Dank unbegrenzter Kilometer können Sie frei planen, ohne am Ende der Reise eine Zusatzrechnung zu befürchten.",
          ],
        },
        {
          h2: "One-Way-Optionen ab Cluj",
          body: [
            "Wer die Reise nicht in Bukarest beenden möchte, kann eine einseitige Anmietung (One-Way) anfragen. Wir erstellen dafür gerne ein passendes Angebot per WhatsApp.",
            "So lässt sich zum Beispiel eine Route über die Transfăgărășan bis zur Schwarzmeerküste ohne Rückfahrt planen.",
          ],
        },
      ],
      faqs: [
        { q: "Habt ihr ein Büro am Flughafen Cluj?", a: "Unser Hauptstandort ist Bukarest. Für Cluj organisieren wir die Fahrzeugübergabe auf Anfrage mit individuellem Angebot." },
        { q: "Wie viel kostet die Überstellung nach Cluj?", a: "Das hängt von Entfernung und Termin ab. Schreiben Sie uns einfach über WhatsApp für ein konkretes Angebot." },
        { q: "Ist eine Kaution nötig?", a: "Nein, wie bei allen unseren Mietwagen ist keine Kaution und keine Kreditkarte erforderlich." },
        { q: "Kann ich das Auto in einer anderen Stadt zurückgeben?", a: "Ja, One-Way-Mieten sind möglich und werden individuell per WhatsApp kalkuliert." },
      ],
      keywords: "Mietwagen Cluj Flughafen, Auto mieten Cluj, Mietwagen Cluj-Napoca",
    },
    "airport-iasi": {
      slug: "mietwagen-iasi-flughafen",
      title: "Mietwagen Iași Flughafen | carentals.ro",
      description: "Auto mieten am Flughafen Iași (IAS): Überstellung ab Bukarest auf Anfrage, ohne Kaution, mit Vollkasko und unbegrenzten Kilometern.",
      eyebrow: "Flughafen Iași (IAS)",
      h1: "Mietwagen am Flughafen Iași",
      intro: "Für Reisen in die Moldau-Region liefern wir Fahrzeuge aus unserer Bukarester Flotte auf Anfrage bis zum Flughafen Iași. Faire Preise ab 35 €/Tag, keine Kaution, volle Transparenz.",
      perks,
      sections: [
        {
          h2: "Überstellung nach Iași",
          body: [
            "Da sich unser Standort in Bukarest befindet, koordinieren wir Übergaben am Flughafen Iași individuell per WhatsApp. Sie erhalten ein Angebot, das Strecke und Übergabezeitpunkt berücksichtigt.",
            "Trotz der Entfernung profitieren Sie von denselben Konditionen wie in Bukarest: keine Kaution, Vollkasko und Rovinieta inklusive.",
          ],
        },
        {
          h2: "Sehenswürdigkeiten rund um Iași",
          body: [
            "Iași ist Ausgangspunkt für Ausflüge zu Klöstern der Bukowina und in die malerische Landschaft der Moldau. Mit einem eigenen Mietwagen erreichen Sie diese Orte unabhängig von Busfahrplänen.",
            "Unbegrenzte Kilometer erlauben es, auch weitere Abstecher spontan einzuplanen.",
          ],
        },
        {
          h2: "Rückgabe und flexible Routen",
          body: [
            "Eine Rückgabe in Bukarest ist im Preis der Standardmiete meist am günstigsten. Alternativ ist eine One-Way-Miete mit individuellem Aufpreis möglich.",
            "Sprechen Sie Ihre gewünschte Route einfach mit uns über WhatsApp ab, wir finden eine praktische Lösung.",
          ],
        },
      ],
      faqs: [
        { q: "Gibt es eine Filiale direkt in Iași?", a: "Nein, unsere Flotte steht in Bukarest. Für Iași organisieren wir eine Überstellung mit individuellem Angebot." },
        { q: "Wie läuft die Buchung ab?", a: "Kontaktieren Sie uns per WhatsApp mit Reisedatum und gewünschtem Übergabeort, wir kümmern uns um den Rest." },
        { q: "Ist eine Kreditkarte erforderlich?", a: "Nein, Zahlung ist per Debitkarte, bar oder Überweisung möglich, ganz ohne Kaution." },
        { q: "Sind Versicherung und Vignette enthalten?", a: "Ja, RCA, CASCO, Rovinieta und unbegrenzte Kilometer sind immer im Preis inbegriffen." },
      ],
      keywords: "Mietwagen Iasi Flughafen, Auto mieten Iasi, Mietwagen Iasi",
    },
    "airport-timisoara": {
      slug: "mietwagen-timisoara-flughafen",
      title: "Mietwagen Timișoara Flughafen | carentals.ro",
      description: "Auto mieten am Flughafen Timișoara (TSR): Überstellung ab Bukarest auf Anfrage, ohne Kaution, mit Vollkasko und unbegrenzten Kilometern.",
      eyebrow: "Flughafen Timișoara (TSR)",
      h1: "Mietwagen am Flughafen Timișoara",
      intro: "Auch im Westen Rumäniens stellen wir Ihnen gerne einen Mietwagen bereit: carentals.ro organisiert die Übergabe am Flughafen Timișoara auf Anfrage, mit den gleichen fairen Konditionen wie in Bukarest.",
      perks,
      sections: [
        {
          h2: "Fahrzeugübergabe in Timișoara",
          body: [
            "Da unsere Flotte in Bukarest stationiert ist, planen wir Übergaben in Timișoara individuell. Kontaktieren Sie uns per WhatsApp mit Ihren Reisedaten, und wir erstellen ein passendes Angebot für die Überstellung.",
            "So sparen Sie sich die Suche nach einem lokalen Anbieter und erhalten dieselbe Qualität und Transparenz wie an unserem Hauptstandort.",
          ],
        },
        {
          h2: "Warum ein Mietwagen im Banat sinnvoll ist",
          body: [
            "Die Region um Timișoara mit ihren historischen Städten und der Nähe zu Serbien und Ungarn lässt sich am besten mit dem eigenen Fahrzeug erkunden.",
            "Unbegrenzte Kilometer und volle Versicherung geben Ihnen die nötige Freiheit für spontane Abstecher.",
          ],
        },
        {
          h2: "Kosten und Buchung",
          body: [
            "Der Grundpreis startet ab 35 €/Tag; die Überstellungskosten nach Timișoara werden separat und transparent kalkuliert.",
            "Eine Kaution wird nicht verlangt, Zahlung erfolgt bequem per Debitkarte, bar oder Überweisung.",
          ],
        },
      ],
      faqs: [
        { q: "Habt ihr ein Büro in Timișoara?", a: "Nein, unser Standort ist Bukarest. Für Timișoara organisieren wir eine Überstellung mit individuellem Angebot." },
        { q: "Wie weit im Voraus sollte ich buchen?", a: "Idealerweise einige Tage im Voraus, damit wir die Überstellung optimal planen können." },
        { q: "Ist eine Kreditkarte notwendig?", a: "Nein, wir verlangen weder Kreditkarte noch Kaution." },
        { q: "Was ist im Mietpreis enthalten?", a: "RCA- und CASCO-Versicherung, Rovinieta sowie unbegrenzte Kilometer sind stets inklusive." },
      ],
      keywords: "Mietwagen Timisoara Flughafen, Auto mieten Timisoara, Mietwagen Timisoara",
    },
    "airport-sibiu": {
      slug: "mietwagen-sibiu-flughafen",
      title: "Mietwagen Sibiu Flughafen | carentals.ro",
      description: "Auto mieten am Flughafen Sibiu (SBZ): Überstellung ab Bukarest auf Anfrage, ohne Kaution, mit Vollkasko und unbegrenzten Kilometern.",
      eyebrow: "Flughafen Sibiu (SBZ)",
      h1: "Mietwagen am Flughafen Sibiu",
      intro: "Sibiu ist der ideale Startpunkt für eine Tour über die Transfăgărășan. carentals.ro liefert Fahrzeuge aus Bukarest auf Anfrage bis zum Flughafen Sibiu, mit vollem Versicherungsschutz und ohne Kaution.",
      perks,
      sections: [
        {
          h2: "Übergabe am Flughafen Sibiu",
          body: [
            "Da unser Standort in Bukarest liegt, wird die Übergabe in Sibiu individuell koordiniert. Schreiben Sie uns per WhatsApp Ihre Reisedaten, wir erstellen ein passendes Angebot für die Überstellung.",
            "Trotz der Distanz gelten dieselben fairen Bedingungen: keine Kaution, keine Kreditkarte, Vollkasko und Rovinieta inklusive.",
          ],
        },
        {
          h2: "Ausgangspunkt für die Transfăgărășan",
          body: [
            "Von Sibiu aus erreichen Sie in kurzer Zeit die berühmte Passstraße Transfăgărășan sowie zahlreiche Burgen Siebenbürgens.",
            "Mit unbegrenzten Kilometern können Sie die Region ganz nach eigenem Tempo erkunden, ohne auf die Uhr zu schauen.",
          ],
        },
        {
          h2: "Flexible Rückgabe",
          body: [
            "Die Rückgabe kann in Bukarest oder, gegen individuelles Angebot, an einem anderen Ort erfolgen.",
            "Sprechen Sie Ihre Wunschroute einfach mit uns ab, wir finden eine praktikable Lösung für Ihre Reise.",
          ],
        },
      ],
      faqs: [
        { q: "Gibt es eine Station direkt in Sibiu?", a: "Nein, wir liefern die Fahrzeuge aus Bukarest auf Anfrage nach Sibiu, mit individuellem Angebot." },
        { q: "Ist die Transfăgărășan mit dem Mietwagen erlaubt?", a: "Ja, die Straße kann in der Saison befahren werden, allerdings ist sie im Winter meist gesperrt." },
        { q: "Brauche ich eine Kaution?", a: "Nein, bei uns ist keine Kaution und keine Kreditkarte erforderlich." },
        { q: "Was kostet die Anmietung?", a: "Der Grundpreis liegt ab 35 €/Tag, die Überstellung nach Sibiu wird separat kalkuliert." },
      ],
      keywords: "Mietwagen Sibiu Flughafen, Auto mieten Sibiu, Mietwagen Sibiu",
    },
    "city-bucharest": {
      slug: "mietwagen-bukarest",
      title: "Mietwagen Bukarest ab 35 €/Tag | carentals.ro",
      description: "Mietwagen Bukarest ohne Kaution: kostenlose Abholung im Büro oder am Flughafen Otopeni, Vollkasko und unbegrenzte Kilometer inklusive.",
      eyebrow: "Hauptstadt Rumäniens",
      h1: "Mietwagen Bukarest – flexibel durch die Hauptstadt und darüber hinaus",
      intro: "Bukarest ist der perfekte Ausgangspunkt für Erkundungen in ganz Rumänien. carentals.ro bietet Ihnen 28 Fahrzeuge zur Auswahl, kostenlose Abholung im Büro oder am Flughafen und faire Preise ohne Kaution.",
      perks,
      sections: [
        {
          h2: "Mietwagen in der Bukarester Innenstadt",
          body: [
            "Unser Büro befindet sich zentral in der Bulevardul Regina Elisabeta 33, nur wenige Minuten von den wichtigsten Sehenswürdigkeiten entfernt. Die Übergabe dort ist selbstverständlich kostenlos.",
            "Alternativ liefern wir Ihr Fahrzeug für 20 € an jede andere Adresse in Bukarest, praktisch etwa direkt zu Ihrem Hotel.",
          ],
        },
        {
          h2: "Vom Flughafen direkt losfahren",
          body: [
            "Wer am Flughafen Otopeni landet, kann das Fahrzeug ebenfalls kostenlos direkt am Terminal übernehmen. Das spart Zeit und lästige Transfers in die Stadt.",
            "So starten Sie Ihre Bukarest-Reise ohne Umwege und ganz ohne Wartezeit an einem Mietwagenschalter.",
          ],
        },
        {
          h2: "Ausflüge ab Bukarest",
          body: [
            "Von Bukarest aus erreichen Sie in wenigen Stunden die Berge des Bucegi-Massivs, Brașov oder die Schwarzmeerküste. Ein eigener Mietwagen macht solche Tagesausflüge unkompliziert.",
            "Dank unbegrenzter Kilometer und inkludierter Vollkaskoversicherung müssen Sie sich um Zusatzkosten keine Gedanken machen.",
          ],
        },
      ],
      faqs: [
        { q: "Wo kann ich das Auto in Bukarest abholen?", a: "Kostenlos in unserem Büro in der Bulevardul Regina Elisabeta 33 oder direkt am Flughafen Otopeni." },
        { q: "Wie viel kostet eine Lieferung an eine andere Adresse?", a: "Eine Lieferung an jede andere Adresse in Bukarest kostet pauschal 20 €." },
        { q: "Ist eine Kaution erforderlich?", a: "Nein, wir verzichten komplett auf Kaution und Kreditkartenpflicht." },
        { q: "Welche Zahlungsarten werden akzeptiert?", a: "Debitkarte, bar in EUR oder RON, sowie Banküberweisung." },
      ],
      keywords: "Mietwagen Bukarest, Auto mieten Bukarest, Autovermietung Bukarest",
    },
    "city-brasov": {
      slug: "mietwagen-brasov",
      title: "Mietwagen Brașov | carentals.ro",
      description: "Auto mieten für Brașov: Fahrzeug ab Bukarest, kostenlose Abholung am Büro oder Flughafen Otopeni, keine Kaution, Vollkasko inklusive.",
      eyebrow: "Tor zu Siebenbürgen",
      h1: "Mietwagen für Brașov und Umgebung",
      intro: "Brașov mit seinen mittelalterlichen Gassen und der Nähe zu Schloss Bran ist ein beliebtes Reiseziel. Holen Sie Ihr Fahrzeug kostenlos in Bukarest oder am Flughafen Otopeni ab und fahren Sie direkt weiter nach Siebenbürgen.",
      perks,
      sections: [
        {
          h2: "Anreise nach Brașov mit dem Mietwagen",
          body: [
            "Von Bukarest aus erreichen Sie Brașov in etwa zwei Stunden über eine landschaftlich reizvolle Strecke durch die Karpaten. Das Fahrzeug übernehmen Sie kostenlos in unserem Büro oder am Flughafen Otopeni.",
            "Für eine direkte Übergabe in Brașov selbst organisieren wir auf Anfrage per WhatsApp eine Überstellung mit individuellem Angebot.",
          ],
        },
        {
          h2: "Sehenswürdigkeiten rund um Brașov",
          body: [
            "Von Brașov aus sind Schloss Bran, die Zinnenburg Rasnov und der Wintersportort Poiana Brașov schnell erreichbar. Ein Mietwagen macht diese Ausflüge deutlich bequemer als mit öffentlichen Verkehrsmitteln.",
            "Unbegrenzte Kilometer erlauben es, spontan weitere Ziele in Siebenbürgen mitzunehmen.",
          ],
        },
        {
          h2: "Faire Konditionen ohne Kaution",
          body: [
            "Wie bei allen unseren Mietwagen ist auch für Fahrten nach Brașov keine Kreditkarte oder Kaution erforderlich.",
            "RCA- und CASCO-Versicherung sowie die Rovinieta sind im Preis ab 35 €/Tag bereits enthalten.",
          ],
        },
      ],
      faqs: [
        { q: "Kann ich das Auto direkt in Brașov abholen?", a: "Auf Anfrage organisieren wir eine Überstellung nach Brașov mit individuellem Angebot per WhatsApp." },
        { q: "Wie lange dauert die Fahrt von Bukarest nach Brașov?", a: "Etwa zwei Stunden, abhängig vom Verkehr." },
        { q: "Ist eine Kaution nötig?", a: "Nein, bei carentals.ro entfällt jegliche Kaution." },
        { q: "Sind Versicherung und Vignette inklusive?", a: "Ja, RCA, CASCO und Rovinieta sind bei jeder Buchung enthalten." },
      ],
      keywords: "Mietwagen Brasov, Auto mieten Brasov, Autovermietung Siebenbürgen",
    },
    "city-cluj": {
      slug: "mietwagen-cluj",
      title: "Mietwagen Cluj-Napoca | carentals.ro",
      description: "Auto mieten für Cluj-Napoca: Fahrzeug ab Bukarest, keine Kaution, Vollkasko und unbegrenzte Kilometer inklusive, ab 35 €/Tag.",
      eyebrow: "Herz Siebenbürgens",
      h1: "Mietwagen für Cluj-Napoca",
      intro: "Cluj-Napoca ist eine lebendige Universitätsstadt und idealer Ausgangspunkt für Siebenbürgen-Touren. carentals.ro stellt Ihnen aus der Bukarester Flotte ein passendes Fahrzeug bereit.",
      perks,
      sections: [
        {
          h2: "Mietwagen für Cluj organisieren",
          body: [
            "Unsere Fahrzeuge stehen in Bukarest bereit. Für eine Übergabe in Cluj-Napoca sprechen Sie uns einfach per WhatsApp an, wir erstellen ein individuelles Angebot für die Überstellung.",
            "So genießen Sie auch in Cluj denselben Service: keine Kaution, keine Kreditkarte, volle Versicherung inklusive.",
          ],
        },
        {
          h2: "Cluj als Ausgangspunkt für Siebenbürgen",
          body: [
            "Von Cluj aus lassen sich Städte wie Turda mit dem berühmten Salzbergwerk oder die Region um Alba Iulia gut erreichen.",
            "Ein eigener Mietwagen mit unbegrenzten Kilometern gibt Ihnen dabei die nötige Freiheit für individuelle Routen.",
          ],
        },
        {
          h2: "Transparente Preise",
          body: [
            "Der Grundpreis beginnt bei 35 €/Tag, die Überstellung nach Cluj wird gesondert kalkuliert und vorab klar kommuniziert.",
            "Zahlung erfolgt per Debitkarte, bar oder Überweisung, komplett ohne Kaution.",
          ],
        },
      ],
      faqs: [
        { q: "Gibt es eine Filiale in Cluj?", a: "Nein, wir liefern Fahrzeuge aus Bukarest auf Anfrage nach Cluj." },
        { q: "Wie buche ich für Cluj?", a: "Am einfachsten über WhatsApp, mit Angabe von Reisedatum und Übergabeort." },
        { q: "Ist eine Kreditkarte notwendig?", a: "Nein, wir verzichten auf Kreditkarten- und Kautionspflicht." },
        { q: "Was ist im Preis enthalten?", a: "RCA- und CASCO-Versicherung, Rovinieta und unbegrenzte Kilometer." },
      ],
      keywords: "Mietwagen Cluj-Napoca, Auto mieten Cluj, Autovermietung Cluj",
    },
    "city-constanta": {
      slug: "mietwagen-constanta",
      title: "Mietwagen Constanța | carentals.ro",
      description: "Auto mieten für Constanța und die Schwarzmeerküste: Fahrzeug ab Bukarest, keine Kaution, Vollkasko inklusive, ab 35 €/Tag.",
      eyebrow: "Rumäniens Schwarzmeerküste",
      h1: "Mietwagen für Constanța und die Küste",
      intro: "Ob Strandurlaub oder Ausflug ins Donaudelta: Constanța ist der ideale Startpunkt für die Schwarzmeerküste. carentals.ro liefert Ihnen ein Fahrzeug aus Bukarest, ohne Kaution und mit voller Versicherung.",
      perks,
      sections: [
        {
          h2: "Anreise an die Schwarzmeerküste",
          body: [
            "Von Bukarest nach Constanța sind es rund zwei Stunden Fahrt über die Autobahn A2. Das Fahrzeug übernehmen Sie kostenlos in unserem Büro oder am Flughafen Otopeni.",
            "Für eine direkte Übergabe in Constanța organisieren wir auf Anfrage per WhatsApp eine Überstellung mit individuellem Angebot.",
          ],
        },
        {
          h2: "Strände und Ausflüge",
          body: [
            "Von Constanța aus erreichen Sie schnell Mamaia, Vama Veche und das Donaudelta. Ein Mietwagen macht es leicht, mehrere Orte an der Küste an einem Tag zu besuchen.",
            "Dank unbegrenzter Kilometer können Sie die gesamte Küstenregion frei erkunden, ohne Zusatzkosten zu befürchten.",
          ],
        },
        {
          h2: "Faire, transparente Preise",
          body: [
            "Der Mietpreis startet bei 35 €/Tag inklusive Vollkasko, Rovinieta und unbegrenzten Kilometern.",
            "Eine Kaution entfällt komplett, gezahlt wird per Debitkarte, bar oder Überweisung.",
          ],
        },
      ],
      faqs: [
        { q: "Kann ich das Auto direkt in Constanța übernehmen?", a: "Auf Anfrage organisieren wir eine Überstellung nach Constanța mit individuellem Angebot." },
        { q: "Wie lange dauert die Fahrt von Bukarest?", a: "Etwa zwei Stunden über die Autobahn A2." },
        { q: "Ist eine Kaution erforderlich?", a: "Nein, bei carentals.ro gibt es keine Kaution." },
        { q: "Was kostet die Miete?", a: "Ab 35 €/Tag inklusive Versicherung, Rovinieta und unbegrenzten Kilometern." },
      ],
      keywords: "Mietwagen Constanta, Auto mieten Schwarzmeerküste Rumänien, Autovermietung Constanta",
    },
    cheap: {
      slug: "guenstiger-mietwagen-rumaenien",
      title: "Günstiger Mietwagen Rumänien ab 35 €/Tag",
      description: "Günstiger Mietwagen in Rumänien ohne Kaution: Preise ab 35 €/Tag, Vollkasko und unbegrenzte Kilometer inklusive, keine versteckten Kosten.",
      eyebrow: "Sparen ohne Kompromisse",
      h1: "Günstiger Mietwagen in Rumänien",
      intro: "Günstig muss nicht kompliziert bedeuten: Bei carentals.ro erhalten Sie Fahrzeuge ab 35 €/Tag inklusive Versicherung, Rovinieta und unbegrenzten Kilometern – ganz ohne Kaution.",
      perks,
      sections: [
        {
          h2: "Wie wir günstige Preise ermöglichen",
          body: [
            "Durch unsere schlanke, lokale Struktur in Bukarest sparen wir Zwischenhändler und geben diese Ersparnis direkt an Sie weiter. Preise starten bereits bei 35 €/Tag.",
            "Es gibt keine versteckten Gebühren: Versicherung, Vignette und Kilometer sind bereits im angegebenen Preis enthalten.",
          ],
        },
        {
          h2: "Keine Kaution spart zusätzlich Geld",
          body: [
            "Bei vielen Anbietern wird ein hoher Betrag auf der Kreditkarte blockiert. Bei uns entfällt das komplett, was Ihr Reisebudget zusätzlich schont.",
            "Zahlung ist einfach per Debitkarte, bar in EUR oder RON, oder per Überweisung möglich.",
          ],
        },
        {
          h2: "Tipps für eine noch günstigere Buchung",
          body: [
            "Wer frühzeitig bucht und flexibel bei den Fahrzeugklassen ist, profitiert von den besten verfügbaren Preisen aus unserer Flotte mit 28 Autos.",
            "Auch die Wahl der Abholung im Büro statt einer Lieferung an eine andere Adresse spart die zusätzliche Liefergebühr von 20 €.",
          ],
        },
      ],
      faqs: [
        { q: "Wie günstig sind die Mietwagen bei carentals.ro?", a: "Preise starten bereits ab 35 €/Tag, inklusive Versicherung und unbegrenzten Kilometern." },
        { q: "Gibt es versteckte Kosten?", a: "Nein, alle wesentlichen Leistungen sind transparent im Preis enthalten." },
        { q: "Spart eine Abholung im Büro Geld?", a: "Ja, die Abholung im Büro oder am Flughafen ist kostenlos, eine Lieferung an andere Adressen kostet 20 €." },
        { q: "Muss ich eine Kaution hinterlegen?", a: "Nein, wir verlangen keine Kaution und keine Kreditkarte." },
      ],
      keywords: "günstiger Mietwagen Rumänien, billig Auto mieten Rumänien, preiswerte Autovermietung Bukarest",
    },
    automatic: {
      slug: "mietwagen-automatik-rumaenien",
      title: "Mietwagen mit Automatik in Rumänien | carentals.ro",
      description: "Automatikwagen in Rumänien mieten: bequemes Fahren ohne Schaltung, Vollkasko und unbegrenzte Kilometer inklusive, keine Kaution.",
      eyebrow: "Komfortabel unterwegs",
      h1: "Mietwagen mit Automatikgetriebe in Rumänien",
      intro: "Für entspanntes Fahren, besonders im Stadtverkehr von Bukarest oder auf Bergstraßen wie der Transfăgărășan, bieten wir Fahrzeuge mit Automatikgetriebe aus unserer 28-köpfigen Flotte an.",
      perks,
      sections: [
        {
          h2: "Vorteile eines Automatikwagens in Rumänien",
          body: [
            "Im dichten Verkehr rumänischer Städte oder auf kurvenreichen Gebirgsstraßen ist ein Automatikgetriebe besonders entspannend, da Sie sich voll auf die Straße konzentrieren können.",
            "Gerade für Reisende, die selten mit Schaltgetriebe fahren, ist die Automatik eine sichere und komfortable Wahl.",
          ],
        },
        {
          h2: "Verfügbarkeit und Buchung",
          body: [
            "Da die Nachfrage nach Automatikfahrzeugen hoch ist, empfehlen wir eine frühzeitige Reservierung über WhatsApp, um die Verfügbarkeit zu sichern.",
            "Alle Automatikwagen enthalten wie gewohnt Vollkaskoversicherung, Rovinieta und unbegrenzte Kilometer ohne Aufpreis.",
          ],
        },
        {
          h2: "Keine Kaution, klare Konditionen",
          body: [
            "Auch bei Automatikfahrzeugen gilt: keine Kreditkarte, keine Kaution. Zahlung ist per Debitkarte, bar oder Überweisung möglich.",
            "Die Preise starten ab 35 €/Tag, abhängig vom gewählten Modell aus unserer Flotte.",
          ],
        },
      ],
      faqs: [
        { q: "Sind Automatikfahrzeuge immer verfügbar?", a: "Die Nachfrage ist hoch, daher empfehlen wir eine frühzeitige Buchung per WhatsApp." },
        { q: "Kostet ein Automatikwagen mehr?", a: "Der Preis hängt vom gewählten Modell ab, startet aber ebenfalls ab 35 €/Tag." },
        { q: "Ist Versicherung inklusive?", a: "Ja, RCA und CASCO sind auch bei Automatikwagen im Preis enthalten." },
        { q: "Brauche ich eine Kaution?", a: "Nein, auch bei Automatikfahrzeugen entfällt die Kaution vollständig." },
      ],
      keywords: "Mietwagen Automatik Rumänien, Automatikwagen mieten Bukarest, Auto mit Automatikgetriebe Rumänien",
    },
    "unlimited-km": {
      slug: "mietwagen-unbegrenzte-kilometer",
      title: "Mietwagen mit unbegrenzten Kilometern Rumänien",
      description: "Mietwagen mit unbegrenzten Kilometern in Rumänien, ohne Kaution, mit Vollkasko und Rovinieta inklusive, ab 35 €/Tag.",
      eyebrow: "Frei fahren, ohne Limit",
      h1: "Mietwagen mit unbegrenzten Kilometern",
      intro: "Ob Rundreise durch Siebenbürgen oder Tagesausflug ans Schwarze Meer: Bei carentals.ro sind bei jeder Buchung unbegrenzte Kilometer inklusive, sodass Sie ohne Sorgen planen können.",
      perks,
      sections: [
        {
          h2: "Warum unbegrenzte Kilometer wichtig sind",
          body: [
            "Rumänien bietet viele weit voneinander entfernte Highlights, von den Karpaten bis zur Küste. Ein Kilometerlimit würde die Reiseplanung unnötig einschränken.",
            "Deshalb ist bei jedem Fahrzeug unserer Flotte diese Leistung standardmäßig enthalten, ohne Aufpreis oder versteckte Klauseln.",
          ],
        },
        {
          h2: "Ideal für Rundreisen",
          body: [
            "Wer eine große Rundreise plant, etwa über die Transfăgărășan, durch Siebenbürgen und weiter ans Schwarze Meer, profitiert besonders von unbegrenzten Kilometern.",
            "So müssen Sie unterwegs nie überlegen, ob sich ein zusätzlicher Abstecher noch lohnt.",
          ],
        },
        {
          h2: "Kombiniert mit voller Versicherung",
          body: [
            "Unbegrenzte Kilometer werden bei uns immer mit RCA- und CASCO-Versicherung sowie der Rovinieta kombiniert, sodass Sie rundum abgesichert unterwegs sind.",
            "Und das alles ohne Kaution, ab 35 €/Tag, mit Zahlung per Debitkarte, bar oder Überweisung.",
          ],
        },
      ],
      faqs: [
        { q: "Gibt es wirklich kein Kilometerlimit?", a: "Richtig, bei jeder Buchung sind unbegrenzte Kilometer im Preis enthalten." },
        { q: "Gilt das für alle Fahrzeuge?", a: "Ja, für die gesamte Flotte mit 28 Fahrzeugen." },
        { q: "Ist Versicherung ebenfalls inklusive?", a: "Ja, RCA und CASCO sind ebenfalls immer inbegriffen." },
        { q: "Muss ich eine Kaution hinterlegen?", a: "Nein, keine Kaution, keine Kreditkarte erforderlich." },
      ],
      keywords: "Mietwagen unbegrenzte Kilometer Rumänien, Auto mieten ohne Kilometerbegrenzung, Mietwagen Bukarest unlimited km",
    },
    "one-way": {
      slug: "mietwagen-one-way-rumaenien",
      title: "One-Way Mietwagen Rumänien | carentals.ro",
      description: "One-Way-Mietwagen in Rumänien: Fahrzeug in einer Stadt abholen, in einer anderen zurückgeben, individuelles Angebot per WhatsApp.",
      eyebrow: "Flexibel unterwegs",
      h1: "One-Way-Mietwagen in Rumänien",
      intro: "Sie möchten Ihre Reise nicht am selben Ort beenden, an dem sie begann? carentals.ro bietet One-Way-Mieten mit individuellem Angebot an, abgestimmt auf Ihre Route.",
      perks: [
        { title: "Flexible Route", text: "Abholung in einer Stadt, Rückgabe in einer anderen – auf Anfrage per WhatsApp." },
        { title: "Individuelles Angebot", text: "Preis richtet sich nach Strecke und Fahrzeug, transparent kommuniziert." },
        { title: "Vollkasko inklusive", text: "Auch bei One-Way-Miete sind RCA, CASCO und Rovinieta enthalten." },
        { title: "Keine Kaution", text: "Wie bei allen unseren Mietwagen entfällt die Kaution komplett." },
      ],
      sections: [
        {
          h2: "So funktioniert die One-Way-Miete",
          body: [
            "Sie teilen uns per WhatsApp mit, wo Sie das Fahrzeug abholen und wo Sie es zurückgeben möchten. Wir erstellen daraufhin ein individuelles Angebot, das die Überstellung berücksichtigt.",
            "Möglich sind zum Beispiel Routen von Bukarest über Siebenbürgen bis zum Flughafen Cluj, oder von Bukarest an die Schwarzmeerküste.",
          ],
        },
        {
          h2: "Beliebte One-Way-Strecken",
          body: [
            "Eine klassische Route führt über die Transfăgărășan von Bukarest nach Sibiu oder Cluj, ideal für alle, die keinen Rückweg fahren möchten.",
            "Auch eine Fahrt an die Küste nach Constanța mit anschließendem Rückflug ab dortigem Flughafen kann als One-Way organisiert werden.",
          ],
        },
        {
          h2: "Kosten und Buchung",
          body: [
            "Die Kosten für One-Way-Mieten hängen von Entfernung und Fahrzeugtyp ab und werden individuell berechnet.",
            "Der Grundpreis der Miete beginnt weiterhin ab 35 €/Tag, ohne Kaution und mit voller Versicherung.",
          ],
        },
      ],
      faqs: [
        { q: "Ist eine One-Way-Miete grundsätzlich möglich?", a: "Ja, wir bieten One-Way-Mieten an und erstellen ein individuelles Angebot je nach Strecke." },
        { q: "Wie viel kostet eine One-Way-Miete zusätzlich?", a: "Das hängt von der Entfernung ab. Kontaktieren Sie uns per WhatsApp für ein konkretes Angebot." },
        { q: "Kann ich in jeder Stadt zurückgeben?", a: "In der Regel ja, sofern wir die Rückgabe organisieren können. Fragen Sie einfach vorab nach." },
        { q: "Ist die Versicherung bei One-Way gleich?", a: "Ja, RCA, CASCO und Rovinieta sind auch bei One-Way-Miete inklusive." },
      ],
      keywords: "One-Way Mietwagen Rumänien, Auto mieten One-Way Bukarest, Mietwagen andere Stadt zurückgeben",
    },
    "seven-seater": {
      slug: "7-sitzer-mietwagen-rumaenien",
      title: "7-Sitzer Mietwagen Rumänien | carentals.ro",
      description: "7-Sitzer und Minivan in Rumänien mieten: viel Platz für Familien und Gruppen, Vollkasko inklusive, keine Kaution, ab 35 €/Tag.",
      eyebrow: "Viel Platz für Familie und Gepäck",
      h1: "7-Sitzer Mietwagen für Rumänien",
      intro: "Für Familien oder größere Reisegruppen bieten wir geräumige 7-Sitzer und Minivans aus unserer Flotte von 28 Fahrzeugen, mit ausreichend Platz für Gepäck und komfortablem Reisen.",
      perks: [
        { title: "Platz für 7 Personen", text: "Ideal für Familien oder Gruppen, die gemeinsam durch Rumänien reisen möchten." },
        { title: "Viel Stauraum", text: "Ausreichend Platz für Gepäck, Kinderwagen oder Sportausrüstung." },
        { title: "Vollkasko inklusive", text: "RCA, CASCO, Rovinieta und unbegrenzte Kilometer wie bei allen unseren Fahrzeugen." },
        { title: "Keine Kaution", text: "Auch für Minivans gilt: keine Kreditkarte, keine Kaution nötig." },
      ],
      sections: [
        {
          h2: "Warum ein 7-Sitzer in Rumänien praktisch ist",
          body: [
            "Bei Rundreisen mit der ganzen Familie oder Freunden lohnt sich ein größeres Fahrzeug: mehr Platz für Gepäck, bequemeres Sitzen auf langen Strecken durch die Karpaten.",
            "Gerade bei Ausflügen an die Schwarzmeerküste oder nach Siebenbürgen ist ein Minivan deutlich komfortabler als mehrere kleinere Fahrzeuge.",
          ],
        },
        {
          h2: "Verfügbarkeit und Reservierung",
          body: [
            "Da 7-Sitzer besonders in der Hauptsaison gefragt sind, empfehlen wir eine frühzeitige Reservierung über WhatsApp.",
            "Wir beraten Sie gerne, welches Modell aus unserer Flotte am besten zu Ihrer Gruppengröße und Ihrem Gepäck passt.",
          ],
        },
        {
          h2: "Gleiche faire Konditionen",
          body: [
            "Auch bei den größeren Fahrzeugen gelten unsere Standardbedingungen: keine Kaution, Vollkasko und Rovinieta inklusive, unbegrenzte Kilometer.",
            "Die Preise variieren je nach Modell, starten aber grundsätzlich ab 35 €/Tag für unsere Flotte.",
          ],
        },
      ],
      faqs: [
        { q: "Wie viele 7-Sitzer habt ihr im Angebot?", a: "Aus unserer Flotte mit 28 Fahrzeugen stehen mehrere Minivans zur Verfügung, Verfügbarkeit erfragen Sie am besten per WhatsApp." },
        { q: "Ist ein 7-Sitzer teurer als ein normaler PKW?", a: "Der Preis hängt vom Modell ab, wir informieren Sie gerne über die aktuelle Verfügbarkeit und Konditionen." },
        { q: "Ist die Versicherung dieselbe wie bei anderen Fahrzeugen?", a: "Ja, RCA und CASCO sind auch bei Minivans immer inklusive." },
        { q: "Muss ich früh buchen?", a: "In der Hauptsaison empfehlen wir eine frühzeitige Reservierung, da die Nachfrage nach größeren Fahrzeugen hoch ist." },
      ],
      keywords: "7-Sitzer Mietwagen Rumänien, Minivan mieten Bukarest, Familienauto Rumänien mieten",
    },
    "guide-transfagarasan": {
      slug: "reisefuehrer-transfagarasan-mietwagen",
      title: "Transfăgărășan mit dem Mietwagen | carentals.ro",
      description: "Reiseführer für die Transfăgărășan mit dem Mietwagen: beste Reisezeit, Route und Tipps für die berühmte Passstraße Rumäniens.",
      eyebrow: "Die berühmteste Passstraße Rumäniens",
      h1: "Die Transfăgărășan mit dem Mietwagen erleben",
      intro: "Die Transfăgărășan gilt als eine der spektakulärsten Bergstraßen Europas. Mit einem Mietwagen von carentals.ro erleben Sie die Serpentinen der Karpaten in Ihrem eigenen Tempo.",
      perks,
      sections: [
        {
          h2: "Beste Reisezeit für die Transfăgărășan",
          body: [
            "Die Passstraße ist üblicherweise von Juli bis Oktober geöffnet, abhängig von der Schneelage in den höheren Lagen der Karpaten.",
            "Außerhalb dieser Saison ist die Straße oft gesperrt, weshalb sich eine vorherige Prüfung des aktuellen Status empfiehlt.",
          ],
        },
        {
          h2: "Route und Highlights",
          body: [
            "Die Strecke verbindet die Region Muntenia mit Siebenbürgen und führt am Bâlea-See sowie zahlreichen Wasserfällen vorbei.",
            "Ein Automatikwagen oder ein souveränes Fahrzeug aus unserer Flotte erleichtert das Fahren auf den engen Serpentinen erheblich.",
          ],
        },
        {
          h2: "Praktische Tipps",
          body: [
            "Planen Sie ausreichend Zeit für Fotostopps ein, und tanken Sie vor der Auffahrt, da es entlang der Strecke wenige Tankstellen gibt.",
            "Mit unbegrenzten Kilometern und voller Versicherung inklusive können Sie die Route entspannt und ohne Zusatzkosten genießen.",
          ],
        },
      ],
      faqs: [
        { q: "Wann ist die Transfăgărășan befahrbar?", a: "In der Regel von Juli bis Oktober, abhängig vom Wetter und der Schneelage." },
        { q: "Brauche ich ein spezielles Fahrzeug?", a: "Ein normaler PKW reicht meist aus, ein Automatikwagen macht die Fahrt jedoch komfortabler." },
        { q: "Gibt es Tankstellen entlang der Strecke?", a: "Nur wenige, daher empfiehlt sich vor der Auffahrt vollzutanken." },
        { q: "Ist die Route im Mietpreis abgedeckt?", a: "Ja, unbegrenzte Kilometer und Vollkasko gelten auch für Fahrten auf der Transfăgărășan." },
      ],
      keywords: "Transfagarasan Mietwagen, Transfagarasan Reiseführer, Rumänien Passstraße Auto",
    },
    "guide-transylvania": {
      slug: "reisefuehrer-siebenbuergen-mietwagen",
      title: "Siebenbürgen mit dem Mietwagen entdecken",
      description: "Reiseführer für Siebenbürgen mit dem Mietwagen: Burgen, mittelalterliche Städte und Bergstraßen bequem selbst erfahren.",
      eyebrow: "Burgen, Berge, mittelalterliche Städte",
      h1: "Siebenbürgen mit dem Mietwagen erkunden",
      intro: "Siebenbürgen gehört zu den vielseitigsten Regionen Rumäniens: von Brașov über Sibiu bis Cluj. Mit einem Mietwagen von carentals.ro erreichen Sie alle Highlights bequem und flexibel.",
      perks,
      sections: [
        {
          h2: "Route durch Siebenbürgen",
          body: [
            "Eine beliebte Route führt von Bukarest über Brașov und Sighișoara nach Sibiu und weiter nach Cluj-Napoca, mit vielen Zwischenstopps an Burgen und historischen Zentren.",
            "Dank unbegrenzter Kilometer und flexibler Rückgabeorte lässt sich diese Route auch als One-Way-Miete planen.",
          ],
        },
        {
          h2: "Highlights unterwegs",
          body: [
            "Sehenswert sind unter anderem Schloss Bran, die Zitadelle von Sighișoara und das historische Zentrum von Sibiu mit seinen bunten Häusern.",
            "Auch kleinere Dörfer mit befestigten Kirchen lohnen einen Abstecher abseits der Hauptstraßen.",
          ],
        },
        {
          h2: "Praktische Hinweise",
          body: [
            "Für Übernachtungen in mehreren Städten ist ein Mietwagen deutlich flexibler als Bus- oder Bahnverbindungen zwischen den kleineren Orten.",
            "Denken Sie an die Rovinieta, die bei uns bereits im Preis inbegriffen ist, sowie an ausreichend Zeit für Fotostopps entlang der Route.",
          ],
        },
      ],
      faqs: [
        { q: "Wie viele Tage sollte ich für Siebenbürgen einplanen?", a: "Für eine entspannte Rundreise empfehlen sich mindestens 4 bis 6 Tage." },
        { q: "Ist eine One-Way-Miete für diese Route möglich?", a: "Ja, wir bieten One-Way-Mieten mit individuellem Angebot an." },
        { q: "Ist die Rovinieta im Preis enthalten?", a: "Ja, die Straßenvignette ist bei uns immer inklusive." },
        { q: "Welche Städte sollte ich unbedingt besuchen?", a: "Brașov, Sighișoara, Sibiu und Cluj-Napoca gehören zu den Höhepunkten Siebenbürgens." },
      ],
      keywords: "Siebenbürgen Mietwagen, Rundreise Siebenbürgen Auto, Transylvanien Reiseführer",
    },
    "guide-black-sea": {
      slug: "reisefuehrer-schwarzmeerkueste-mietwagen",
      title: "Schwarzmeerküste mit dem Mietwagen | carentals.ro",
      description: "Reiseführer für die rumänische Schwarzmeerküste mit dem Mietwagen: Strände, Ausflüge und Tipps für die Anreise ab Bukarest.",
      eyebrow: "Strände und Sonne am Schwarzen Meer",
      h1: "Die Schwarzmeerküste mit dem Mietwagen erkunden",
      intro: "Von Mamaia bis Vama Veche bietet die rumänische Schwarzmeerküste vielfältige Strände. Mit einem Mietwagen von carentals.ro sind Sie unabhängig von Bus- oder Bahnverbindungen unterwegs.",
      perks,
      sections: [
        {
          h2: "Anreise von Bukarest zur Küste",
          body: [
            "Die Fahrt von Bukarest an die Küste dauert über die Autobahn A2 etwa zwei Stunden bis Constanța. Das Fahrzeug übernehmen Sie kostenlos in unserem Büro oder am Flughafen Otopeni.",
            "In der Hauptsaison kann der Verkehr an Wochenenden dichter sein, weshalb sich eine Anreise unter der Woche oft anbietet.",
          ],
        },
        {
          h2: "Beliebte Ziele an der Küste",
          body: [
            "Mamaia ist bekannt für seine breiten Sandstrände und Beachclubs, während Vama Veche eher für ein entspanntes, alternatives Flair steht.",
            "Auch das Donaudelta lässt sich von der Küste aus als Tagesausflug gut erreichen, ideal für Naturliebhaber.",
          ],
        },
        {
          h2: "Praktische Reisetipps",
          body: [
            "In der Hochsaison lohnt sich eine frühzeitige Buchung des Fahrzeugs, da die Nachfrage stark steigt.",
            "Dank unbegrenzter Kilometer können Sie problemlos zwischen mehreren Küstenorten wechseln, ohne zusätzliche Kosten zu befürchten.",
          ],
        },
      ],
      faqs: [
        { q: "Wie lange dauert die Fahrt von Bukarest ans Meer?", a: "Etwa zwei Stunden über die Autobahn A2 bis Constanța." },
        { q: "Welcher Ort eignet sich für Familien?", a: "Mamaia ist mit seinen breiten Stränden und der Infrastruktur besonders familienfreundlich." },
        { q: "Kann ich das Donaudelta mit dem Mietwagen besuchen?", a: "Ja, ein Tagesausflug ins Donaudelta ist von der Küste aus gut möglich." },
        { q: "Sollte ich in der Hochsaison früh buchen?", a: "Ja, in den Sommermonaten empfiehlt sich eine frühzeitige Reservierung." },
      ],
      keywords: "Schwarzmeerküste Mietwagen, Auto mieten Mamaia, Rumänien Küste Reiseführer",
    },
    "rules-rovinieta": {
      slug: "rovinieta-rumaenien-regeln",
      title: "Rovinieta Rumänien – Regeln und Infos | carentals.ro",
      description: "Alles zur Rovinieta in Rumänien: Was sie ist, wer sie braucht und warum sie bei carentals.ro immer im Mietpreis enthalten ist.",
      eyebrow: "Straßenvignette in Rumänien",
      h1: "Die Rovinieta: Straßenvignette in Rumänien erklärt",
      intro: "Für die Benutzung der Nationalstraßen in Rumänien ist die Rovinieta, eine elektronische Straßenvignette, verpflichtend. Bei carentals.ro ist sie bei jeder Miete bereits inklusive.",
      perks,
      sections: [
        {
          h2: "Was ist die Rovinieta?",
          body: [
            "Die Rovinieta ist eine elektronische Vignette, die zur Nutzung des rumänischen Nationalstraßennetzes berechtigt. Sie wird über das Kennzeichen des Fahrzeugs registriert, es gibt keine physische Vignette am Fahrzeug.",
            "Ohne gültige Rovinieta drohen empfindliche Bußgelder bei Kontrollen, weshalb sie für jede Fahrt außerhalb der Städte notwendig ist.",
          ],
        },
        {
          h2: "Warum sie bei carentals.ro inklusive ist",
          body: [
            "Um Ihnen unnötigen Aufwand zu ersparen, ist die Rovinieta bei jeder Miete standardmäßig im Preis enthalten. Sie müssen sich um nichts kümmern.",
            "So können Sie sich voll auf Ihre Reise konzentrieren, egal ob Sie in die Berge, an die Küste oder nach Siebenbürgen fahren.",
          ],
        },
        {
          h2: "Weitere wichtige Hinweise",
          body: [
            "Beachten Sie, dass die Rovinieta nur für Nationalstraßen und Autobahnen gilt, nicht für innerstädtische Fahrten.",
            "Bei Fragen zu Gültigkeitsbereichen oder anderen Verkehrsregeln in Rumänien hilft Ihnen unser Team gerne per WhatsApp weiter.",
          ],
        },
      ],
      faqs: [
        { q: "Muss ich die Rovinieta selbst kaufen?", a: "Nein, sie ist bei carentals.ro bereits in jedem Mietpreis enthalten." },
        { q: "Was passiert ohne gültige Rovinieta?", a: "Es drohen Bußgelder bei Verkehrskontrollen, deshalb sorgen wir dafür, dass sie immer gültig ist." },
        { q: "Gilt die Rovinieta auch in Städten?", a: "Sie wird vor allem für Nationalstraßen und Autobahnen außerhalb der Städte benötigt." },
        { q: "Ist die Rovinieta an das Fahrzeug oder an mich gebunden?", a: "Sie ist elektronisch an das Kennzeichen des jeweiligen Mietfahrzeugs gebunden." },
      ],
      keywords: "Rovinieta Rumänien, Straßenvignette Rumänien, Rovinieta Mietwagen",
    },
    "rules-winter-tires": {
      slug: "winterreifen-rumaenien-regeln",
      title: "Winterreifen-Pflicht Rumänien | carentals.ro",
      description: "Winterreifen-Regeln in Rumänien: Wann sie Pflicht sind und wie carentals.ro Ihr Mietfahrzeug entsprechend ausstattet.",
      eyebrow: "Sicher unterwegs im Winter",
      h1: "Winterreifen-Pflicht in Rumänien",
      intro: "In den Wintermonaten gelten in Rumänien besondere Regeln zur Bereifung. carentals.ro sorgt dafür, dass Ihr Mietfahrzeug bei Bedarf entsprechend ausgestattet ist.",
      perks,
      sections: [
        {
          h2: "Wann Winterreifen in Rumänien Pflicht sind",
          body: [
            "Bei winterlichen Straßenverhältnissen mit Schnee, Eis oder Reifglätte müssen Fahrzeuge in Rumänien mit Winterreifen oder Ganzjahresreifen mit entsprechender Kennzeichnung ausgestattet sein.",
            "Diese Pflicht gilt in der Regel von November bis März, kann aber je nach Wetterlage variieren.",
          ],
        },
        {
          h2: "Wie carentals.ro dies handhabt",
          body: [
            "In der kalten Jahreszeit stellen wir unsere Flotte auf Winter- beziehungsweise Ganzjahresreifen um, sodass Sie sich um die technische Ausstattung keine Gedanken machen müssen.",
            "Sollten Sie eine Fahrt in besonders schneereiche Bergregionen wie die Karpaten planen, sprechen Sie uns gerne vorab per WhatsApp darauf an.",
          ],
        },
        {
          h2: "Zusätzliche Sicherheitstipps",
          body: [
            "Auf Bergstraßen wie der Transfăgărășan kann es im Winter zu vollständigen Sperrungen kommen, informieren Sie sich daher vorab über den aktuellen Straßenzustand.",
            "Bei winterlichen Bedingungen empfiehlt sich zudem eine angepasste, vorsichtige Fahrweise, besonders in ländlichen Regionen.",
          ],
        },
      ],
      faqs: [
        { q: "Ab wann gilt die Winterreifen-Pflicht?", a: "In der Regel von November bis März, abhängig von den tatsächlichen Wetterbedingungen." },
        { q: "Sind eure Mietfahrzeuge im Winter entsprechend ausgestattet?", a: "Ja, wir stellen unsere Flotte in der kalten Jahreszeit auf geeignete Reifen um." },
        { q: "Kann ich die Transfăgărășan im Winter befahren?", a: "Meist nicht, da die Passstraße im Winter üblicherweise gesperrt ist." },
        { q: "Was, wenn ich in die Berge fahren möchte?", a: "Sprechen Sie uns vorab per WhatsApp an, wir beraten Sie gerne zu geeigneten Fahrzeugen und Routen." },
      ],
      keywords: "Winterreifen Rumänien, Winterreifenpflicht Rumänien, Mietwagen Winter Rumänien",
    },
    "rules-speed-cameras": {
      slug: "blitzer-tempolimits-rumaenien",
      title: "Blitzer und Tempolimits in Rumänien | carentals.ro",
      description: "Tempolimits und Blitzer in Rumänien: die wichtigsten Regeln für Ihren Mietwagen, damit Ihre Reise ohne Bußgelder verläuft.",
      eyebrow: "Sicher und regelkonform fahren",
      h1: "Tempolimits und Blitzer in Rumänien",
      intro: "Damit Ihre Reise mit dem Mietwagen entspannt verläuft, sollten Sie die rumänischen Tempolimits und die verbreitete Blitzerkontrolle kennen. Hier die wichtigsten Regeln im Überblick.",
      perks,
      sections: [
        {
          h2: "Geltende Tempolimits",
          body: [
            "Innerorts gilt in der Regel Tempo 50, außerorts meist 90 km/h und auf Autobahnen bis zu 130 km/h, sofern keine anderen Schilder etwas anderes vorschreiben.",
            "Achten Sie besonders bei der Durchfahrt kleinerer Ortschaften auf reduzierte Geschwindigkeitsbegrenzungen, die oft streng kontrolliert werden.",
          ],
        },
        {
          h2: "Blitzer und Kontrollen",
          body: [
            "In Rumänien sind sowohl feste als auch mobile Blitzer sowie Polizeikontrollen mit Laserpistolen weit verbreitet, häufig an Ortseingängen und Ausfallstraßen.",
            "Bußgelder werden in der Regel direkt vor Ort erhoben oder später über das Mietfahrzeug nachverfolgt, daher empfiehlt sich strikte Einhaltung der Limits.",
          ],
        },
        {
          h2: "Tipps für eine entspannte Fahrt",
          body: [
            "Nutzen Sie ein Navigationssystem oder eine App mit Tempolimit-Anzeige, um stets über die aktuell gültige Geschwindigkeit informiert zu sein.",
            "Bei Fragen zu Verkehrsregeln oder im Falle eines Bußgeldbescheids steht Ihnen unser Team jederzeit über WhatsApp zur Verfügung.",
          ],
        },
      ],
      faqs: [
        { q: "Wie hoch ist das Tempolimit auf Autobahnen?", a: "In der Regel 130 km/h, sofern keine niedrigere Begrenzung ausgeschildert ist." },
        { q: "Gibt es viele Blitzer in Rumänien?", a: "Ja, sowohl feste als auch mobile Kontrollen sind weit verbreitet, besonders an Ortseingängen." },
        { q: "Was passiert bei einem Bußgeld während der Miete?", a: "Kontaktieren Sie uns über WhatsApp, wir helfen Ihnen bei der weiteren Klärung." },
        { q: "Gilt innerorts überall Tempo 50?", a: "In den meisten Fällen ja, achten Sie aber immer auf abweichende Beschilderung." },
      ],
      keywords: "Blitzer Rumänien, Tempolimit Rumänien, Verkehrsregeln Rumänien Mietwagen",
    },
    "airport-pickup": {
      slug: "flughafen-abholung-otopeni-anleitung",
      title: "Mietwagen Abholung Flughafen Otopeni – Anleitung",
      description: "Schritt-für-Schritt-Anleitung zur Mietwagen-Abholung am Flughafen Otopeni: von der Landung bis zur Übergabe, ohne Kaution.",
      eyebrow: "Schritt für Schritt erklärt",
      h1: "So funktioniert die Mietwagen-Abholung am Flughafen Otopeni",
      intro: "Damit Ihre Ankunft in Bukarest reibungslos verläuft, erklären wir hier genau, wie die Übergabe Ihres Mietwagens am Flughafen Henri Coandă (Otopeni) abläuft.",
      perks: [
        { title: "Kontakt nach der Landung", text: "Schreiben Sie uns direkt nach der Landung über WhatsApp +40738792499." },
        { title: "Treffpunkt am Terminal", text: "Wir vereinbaren einen genauen Treffpunkt im Ankunftsbereich von Otopeni." },
        { title: "Fahrzeugcheck vor Ort", text: "Gemeinsame Prüfung des Fahrzeugs und Unterzeichnung des Vertrags." },
        { title: "Keine Kaution nötig", text: "Zahlung per Debitkarte, bar oder Überweisung, ohne Kreditkarte." },
      ],
      sections: [
        {
          h2: "Schritt 1: Kontakt nach der Landung",
          body: [
            "Sobald Sie gelandet sind und Ihr Gepäck haben, schreiben Sie uns kurz über WhatsApp an +40738792499. Teilen Sie uns mit, dass Sie angekommen sind.",
            "Unser Team ist 24/7 erreichbar, sodass die Abholung auch bei Nachtflügen oder Verspätungen problemlos funktioniert.",
          ],
        },
        {
          h2: "Schritt 2: Treffpunkt und Übergabe",
          body: [
            "Wir vereinbaren einen genauen Treffpunkt im Ankunftsbereich des Flughafens Henri Coandă und bringen das gebuchte Fahrzeug direkt dorthin.",
            "Vor Ort prüfen wir gemeinsam den Zustand des Fahrzeugs, klären letzte Fragen und unterschreiben den Mietvertrag – meist dauert das nur wenige Minuten.",
          ],
        },
        {
          h2: "Schritt 3: Losfahren ohne Kaution",
          body: [
            "Da bei carentals.ro keine Kaution und keine Kreditkarte erforderlich sind, zahlen Sie einfach per Debitkarte, bar in EUR oder RON, oder per Überweisung.",
            "Anschließend erhalten Sie die Fahrzeugschlüssel und können direkt losfahren, ganz ohne Umwege über einen Mietwagenschalter im Terminal.",
          ],
        },
      ],
      faqs: [
        { q: "Wann sollte ich euch kontaktieren?", a: "Am besten direkt nach der Landung, sobald Sie Ihr Gepäck abgeholt haben." },
        { q: "Wo genau findet die Übergabe statt?", a: "Im Ankunftsbereich des Flughafens Henri Coandă, den genauen Treffpunkt vereinbaren wir per WhatsApp." },
        { q: "Was, wenn mein Flug Verspätung hat?", a: "Kein Problem, wir sind 24/7 erreichbar und passen uns Ihrer tatsächlichen Ankunftszeit an." },
        { q: "Brauche ich eine Kreditkarte für die Übergabe?", a: "Nein, Zahlung per Debitkarte, bar oder Überweisung genügt, eine Kaution ist nicht erforderlich." },
      ],
      keywords: "Mietwagen Abholung Otopeni, Flughafen Bukarest Auto abholen, Anleitung Mietwagen Otopeni",
    },
  },
};
